import React, { Component } from "react";
import "./ScheduleEntry.css";
import { fixTime } from "../../helpers";

import HeaderCard from "./HeaderCard";

class ScheduleEntryTitle extends Component {
  render() {
    let cross = true;
    let size = "half";
    const data = this.props.appointment;
    if (data.CrossStreet === " / ") {
      cross = false;
      size = "long";
    }
    return (
      <div className="schedule-class-wrapper">
        <div className="schedule-class">
          <HeaderCard
            headerClass={`cyan ${size}`}
            headerLabel="Time"
            headerValue={fixTime(data.Time)}
          />
          <HeaderCard
            headerClass={`green ${size}`}
            headerLabel="Appointment Type"
            headerValue={data.Appointments}
          />
          <HeaderCard
            headerClass={`magenta ${size}`}
            headerLabel="Location"
            headerValue={data.Location}
          />
          {cross && (
            <HeaderCard
              headerClass="red half"
              headerLabel="Cross Street"
              headerValue={data.CrossStreet}
            />
          )}
        </div>
      </div>
    );
  }
}

export default ScheduleEntryTitle;
